<script setup lang="ts">
const { locale } = useI18n()
const switchLocalePath = useSwitchLocalePath()
</script>

<template>
  <UApp>
    <div class="fixed right-4 top-4 z-50">
      <UButton
        :to="switchLocalePath(locale === 'mn' ? 'en' : 'mn')"
        color="neutral"
        variant="ghost"
        size="sm"
        icon="i-lucide-orbit"
      >
        {{ locale === 'mn' ? 'EN' : 'MN' }}
      </UButton>
    </div>
    <UMain>
      <slot />
    </UMain>
  </UApp>
</template>
